import * as types from "./dadosSolicitante.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  getSolicitante: (data) => ({
    type: types.SOLICITANTE_GET,
    payload: data,
  }),
  setSolicitante: (data) => ({
    type: types.SOLICITANTE_SET,
    payload: data,
  }),
  setEnderecoSolicitante: (data) => ({
    type: types.SOLICITANTE_ENDERECO_SET,
    payload: data,
  }),
  resetFormSolicitante: () => ({
    type: types.DADOSSOLICITANTE_RESETFORM,
  }),
  resetForm: () => ({
    type: commonActionType.RESET,
  }),
};
